import React, { useState, useEffect } from 'react';
import { MotifIcon } from '@ey-xd/motif-react';
import {
  SidebarQuarterlyContainer,
  AccordionTitle,
  AccordionContent,
  AccordionContentFuture,
  AccordionText,
  OrangeColorStyle,
  RowStyle,
  LegendTextStyle,
  QuarterHeaderTitle,
  SidebarDetailsContainer,
  SidebarContainer,
  SidebarExpandedContainer,
  SidebarCollapsedContainer,
  SidebarWarningContainer,
  SidebarWarningText,
  SidebarWarningIcon,
} from '../../../atoms/sidebar/sidebar.styles';
import Legend from './legend';
import MontlySideBar from './montlySideBar';
import flagOutline from '../../../assets/icons/flagOutline.png';
import flagImage from '../../../assets/icons/flag-alt.png';
import { CrmChartQuarterly } from './crmChartQuarterly';
import { formatNumberWithKAndM, getTodaysDate } from '../../../../util/commonUtil';

import {
  Current_User,
  Now_Next_Beyond_Sidebar_Data_State,
  Recoil_Quarter_State,
  Year_Wise_Data_State,
  Refresh_Pl_Sidebar_Data,
  Trigger_Update_Pl_Sidebar_Data,
  SidebarExpandCollapseState,
  System_Date_Time_State,
} from '../../../../recoil/recoil';
import { useRecoilState, useRecoilValue } from 'recoil';
import { getNowNextBeyondSidebarData } from '../../../../services/pursuitLeaderServices';
import { FORECAST_SIDEBAR_DATA_CONST, SIDEBAR_WARNING,FORECAST_SIDEBAR_QUARTER_CONST } from '../../../../constants/commonConstants';
import SpinnerLoader from '../../../atoms/SpinnerLoader';
import QuarterlyCollapsedSidebar from './quarterlyCollapsedSidebar';
import QuarterlyExpandedSidebar from './quarterlyExpandedSidebar';
import { actionIcReportProblem24px } from '@ey-xd/motif-react/assets/icons';
import { isMobile, isTablet } from 'react-device-detect';

const QuarterlySidebar = () => {
  const [yearQuaterWiseData, setYearQuaterWiseData] = useRecoilState(Year_Wise_Data_State);
  const [refreshPLSidebarData, setRefreshPLSidebarData] = useRecoilState(Refresh_Pl_Sidebar_Data);
  const [triggerUpdatePlSidebarData, setTriggerUpdatePlSidebarData] = useRecoilState(
    Trigger_Update_Pl_Sidebar_Data,
  );
  const [expandedQuarter, setExpandedQuarter] = useState('');
  const [nowNextBeyondSidebarData, setNowNextBeyondSidebarData] = useRecoilState(
    Now_Next_Beyond_Sidebar_Data_State,
  );
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  const quarterData = useRecoilValue(Recoil_Quarter_State);
  const currentUser = useRecoilValue(Current_User);
  const [isLoading, setIsLoading] = useState(true);
  const [sidebarExpandState, setSidebarExpandState] = useRecoilState(SidebarExpandCollapseState);

  let todaysDate = getTodaysDate(systemDateTime);
  let currentYear;
  let sidebarData = {
    NOW: null,
    NEXT: null,
    BEYOND: null,
  };
  const screenWidth = window.innerWidth;

  setTimeout(() => {
    if (quarterData != null && expandedQuarter == '') {
      let expandThisQuarter = quarterData.quarter;
      setExpandedQuarter(expandThisQuarter);
    }
  }, 1000);

  if (quarterData != null) {
    currentYear = quarterData.fiscal_year;
  }

  useEffect(() => {
    if((isMobile || isTablet) && screenWidth < 1170 && !sidebarExpandState) {
      setSidebarExpandState(!sidebarExpandState);
      localStorage.setItem('isSidebarExpanded', !sidebarExpandState);
    }
  }, []);

  useEffect(() => {
    if (quarterData != null) {
      const fetchData = async () => {
        try {
          // NOW
          let nowSideBarData = await getNowNextBeyondSidebarData(
            FORECAST_SIDEBAR_DATA_CONST.NOW,
            currentUser.email,
            todaysDate,
            currentYear,
            null,
          );
          sidebarData.NOW = nowSideBarData;

          // NEXT
          let nextSideBarData = await getNowNextBeyondSidebarData(
            FORECAST_SIDEBAR_DATA_CONST.NEXT,
            currentUser.email,
            todaysDate,
            currentYear,
            null,
          );
          sidebarData.NEXT = nextSideBarData;

          // BEYOND
          let beyondSideBarData = await getNowNextBeyondSidebarData(
            FORECAST_SIDEBAR_DATA_CONST.BEYOND,
            currentUser.email,
            todaysDate,
            currentYear,
            quarterData.quarter,
          );
          sidebarData.BEYOND = beyondSideBarData;

          setNowNextBeyondSidebarData(sidebarData);

          if (!!sessionStorage.getItem('CrmUpdatedOpportunities')) {
            setTriggerUpdatePlSidebarData(!triggerUpdatePlSidebarData);
            setTimeout(() => {
              setIsLoading(false);
            }, 1000);
          }
        } catch (error) {
          console.error('Error:', error);
          setIsLoading(false);
        }
      };

      fetchData();
    }
  }, [refreshPLSidebarData]);

  const toggleAccordion = quarter => {
    if (expandedQuarter === quarter) {
      setExpandedQuarter(null);
    } else {
      setExpandedQuarter(quarter);
    }
  };

  // {!isMobile && screenWidth > 1170 ? (
  return (
    <>
      {isLoading ? (
        <div style={{ position: 'relative', top: '50%', left: '50%' }}>
          <SpinnerLoader color="#ffffff" />
        </div>
      ) : (
        <SidebarContainer>
          {!!nowNextBeyondSidebarData && !sidebarExpandState ? (
            <SidebarCollapsedContainer>
              {Object.entries(nowNextBeyondSidebarData).map(([key, item]) => (
                <QuarterlyCollapsedSidebar
                  data={item?.quarterInfoData}
                  quarter={item?.quarter}
                  quarterTitle={item?.title_name}
                />
              ))}
            </SidebarCollapsedContainer>
          ) : (
            <SidebarExpandedContainer>
              <SidebarWarningContainer>
                <SidebarWarningIcon><MotifIcon style={{ color: '#ED6500', width: '24px', height: '24px' }} src={actionIcReportProblem24px} /></SidebarWarningIcon>
                <SidebarWarningText>{SIDEBAR_WARNING.WARNING_MESSAGE}</SidebarWarningText>
              </SidebarWarningContainer>

              {Object.entries(nowNextBeyondSidebarData).map(([key, item]) => (
                <QuarterlyExpandedSidebar
                  data={item?.quarterInfoData}
                  quarter={item?.title_name === FORECAST_SIDEBAR_QUARTER_CONST.BEYOND ? item?.beyond_quarter : item?.quarter }
                  quarterTitle={item?.title_name}
                  year={item?.title_name === FORECAST_SIDEBAR_QUARTER_CONST.BEYOND ? item?.beyond_year : item?.year}
                  expanded={'expanded'}
                  toggleAccordion={() => toggleAccordion('Q1')}
                />
              ))}
            </SidebarExpandedContainer>
          )}
        </SidebarContainer>
      )}
    </>
  );
};

export default QuarterlySidebar;
